import { TSpacing, TTheme } from '../../theme';

export type TSpacingOptions = TSpacing | string;

export function spacing(
    ...spacings: [
        TSpacingOptions,
        TSpacingOptions?,
        TSpacingOptions?,
        TSpacingOptions?
    ]
) {
    return ({ theme }: { theme: TTheme }) => {
        return spacings
            .map(spacing =>
                spacing || spacing === 0 ? getSpacing(theme, spacing) : ''
            )
            .filter(Boolean)
            .join(' ');
    };
}

function getSpacing(theme: TTheme, spacing: TSpacingOptions) {
    if (isValidSpacing(theme, spacing)) {
        return theme.spacing[spacing];
    }
    return spacing;
}

function isValidSpacing(
    theme: TTheme,
    spacing: TSpacingOptions
): spacing is TSpacing {
    return spacing in theme.spacing;
}
